// API configuration constants
// Import from shared config to maintain single source of truth
const {
  CONFIG_API_EXTERNAL_PREFIX,
  MONITOR_API_PREFIX,
  DATA_API_PREFIX,
} = require('../../config/api-constants');

export { CONFIG_API_EXTERNAL_PREFIX, MONITOR_API_PREFIX, DATA_API_PREFIX };

export const buildConfigApiUrl = (endpoint) =>
  `/${CONFIG_API_EXTERNAL_PREFIX}${endpoint}`;
export const buildMonitorApiUrl = (endpoint) =>
  `/${MONITOR_API_PREFIX}${endpoint}`;

/**
 * Make a POST request with JSON body and handle errors
 * @param {string} url - The URL to fetch
 * @param {Object} body - Request body to be JSON stringified
 * @param {string} defaultErrorMessage - Default error message if none in response
 * @returns {Promise<Object>} Parsed JSON response
 * @throws {Error} If response is not ok
 */
export const postJson = async (url, body, defaultErrorMessage) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || defaultErrorMessage);
  }

  return response.json();
};

/**
 * Make a GET request and handle errors.
 * @param {string} url - The URL to fetch
 * @param {string} defaultErrorMessage - Default error message if none in response
 * @returns {Promise<Object>} Parsed JSON response
 * @throws {Error} If response is not ok
 */
export const getJson = async (url, defaultErrorMessage) => {
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || defaultErrorMessage);
  }

  return response.json();
};

/**
 * Make a DELETE request and handle errors.
 * @param {string} url - The URL to fetch
 * @param {string} defaultErrorMessage - Default error message if none in response
 * @returns {Promise<Object>} Parsed JSON response
 * @throws {Error} If response is not ok
 */
export const deleteJson = async (url, defaultErrorMessage) => {
  const response = await fetch(url, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || defaultErrorMessage);
  }

  return response.json();
};

export const buildDataApiUrl = (endpoint) =>
  `/${DATA_API_PREFIX}${endpoint}`;
